import React from 'react'
import { useIntl } from 'react-intl'

import { HouseStudyDayGlobalFieldProps } from '../form-container/HouseStudyDayGlobalFormContainer'
import { ControlledSwitchField } from '../../../../../../../forms'

export const HouseStudyDayGlobalIsEnabledField = ({
  control,
  isFieldDisabled,
}: Omit<HouseStudyDayGlobalFieldProps, 'currencyArea'>) => {
  const intl = useIntl()
  return (
    <ControlledSwitchField
      control={control}
      name='isEnabled'
      label={intl.formatMessage({
        defaultMessage: 'Acceptez-vous les séjours à la journée ?',
        id: 'ui.HouseStudyDayGlobalIsEnabledField.label',
      })}
      inline={true}
      disabled={isFieldDisabled}
    />
  )
}
